<template>
    <div>
        <div class="load-more"
             v-if="noMore">亲，没有更多的数据了 ~</div>
        <div class="load-more"
             v-else>
            <img class="loading_icon"
                 src="./img/icon_loading.png" />正在努力加载中...
        </div>
    </div>
</template>

<script>
export default {
    name: "loadmore",
    props: ["noMore"],
    data () {
        return {

        };
    }
}
</script>

<style lang="scss">
.load-more {
    line-height: 80px / $ppr;
    color: #9b9b9b;
    text-align: center;
    font-size: 24px / $ppr;
    display: block;
    clear: both;
    .loading_icon {
        width: 30px / $ppr;
        height: 30px / $ppr;
        display: inline-block;
        vertical-align: middle;
        margin-right: 16px / $ppr;
        margin-top: -4px / $ppr;
        animation: 1s rotate360 infinite linear;
    }
}

@keyframes rotate360 {
    from {
        transform: rotateZ(0);
    }
    to {
        transform: rotateZ(360deg);
    }
}
</style>